// Admin-only cost/cache debug strip (Task 4.2, D-A7; site-assistant SA23). Renders
// straight from the "debug" SSE event api/src/aiChat.ts sends at the end of every
// turn — proof caching is (or is not yet — see the plan's Cost model correction)
// working. Attached to the reply it describes, collapsed to one readable line.

import {
  formatCostUsd,
  formatCount,
  formatDebugSummary,
  formatSeconds,
  type AiDebugInfo,
} from "../../lib/aiChat/debugFormat.js";

export type { AiDebugInfo };

export function AiDebugStrip({ debug }: { debug: AiDebugInfo }) {
  return (
    <details className="mr-6 mt-1 text-[11px] leading-snug text-muted">
      <summary className="cursor-pointer select-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500/40">
        {formatDebugSummary(debug)}
      </summary>
      <dl className="mt-1 grid grid-cols-[auto_1fr] gap-x-3 gap-y-0.5 rounded-lg border border-line bg-slate-50 px-3 py-2">
        <dt>Model</dt>
        <dd className="break-all">{debug.modelId}</dd>
        <dt>In / out tokens</dt>
        <dd>
          {formatCount(debug.inTokens)} / {formatCount(debug.outTokens)}
        </dd>
        <dt>Cache read / write</dt>
        <dd>
          {formatCount(debug.cacheReadTokens)} / {formatCount(debug.cacheCreationTokens)}
        </dd>
        <dt>Tool rounds</dt>
        <dd>{debug.rounds}</dd>
        <dt>Duration</dt>
        <dd>{formatSeconds(debug.durationMs)}</dd>
        <dt>Est. cost</dt>
        <dd>{formatCostUsd(debug.estCostUsd)}</dd>
      </dl>
    </details>
  );
}
